import { Navigate } from "react-router-dom";
import { useSelectedTheme, useThemesContext } from "../../hooks/themeHooks";

export function DefaultThemeGuard() {
  const { themes } = useThemesContext();
  const currentTheme = useSelectedTheme(themes);

  return <>{currentTheme && <Navigate to={`${currentTheme.id}`} />}</>;
}
